// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7bb29a1","455":"bac4d1ef"}[chunkId] + ".chunk.js";
};